<template>
  <div>
    <b-icon-plus-circle-fill class="plus icon" />
    <div>Új feltétel hozzáadása</div>
  </div>
</template>
<script>
import { BIconPlusCircleFill } from 'bootstrap-vue'
export default {
  components: { BIconPlusCircleFill },
  name: 'AddNewField'
}
</script>
<style scoped>
svg {
  display: inline;
  margin-right: 16px;
}
div {
  display: inline;
}
</style>
